module.exports = __webpack_public_path__ + "img/basket-product.59832cc9.png";